const CARD_LINE_RE = /^(\d+)\s+(.+)$/;

const normalizeCardName = (name) =>
    String(name || '').replace(/-/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();

export const normalizeDeckCards = (rawCards) => {
    if (!rawCards?.trim()) return '';
    const entries = rawCards
        .split('\n')
        .map(l => l.trim())
        .filter(l => l && CARD_LINE_RE.test(l))
        .map(l => {
            const [, qty, name] = CARD_LINE_RE.exec(l);
            return `${qty} ${name.trim()}`;
        });
    entries.sort();
    return entries.join('\n');
};

const parseDeckCardNames = (rawCards) => {
    if (!rawCards?.trim()) return [];
    return rawCards
        .split('\n')
        .map(l => l.trim())
        .filter(l => l)
        .map(l => {
            const match = CARD_LINE_RE.exec(l);
            return match ? match[2].trim() : null;
        })
        .filter(Boolean);
};

export const findDuplicateDeck = (rawCards, allDecks, archetypeId, archetypes, excludeDeckId = null) => {
    if (!rawCards?.trim() || !allDecks?.length) return null;

    const selectedArchetype = archetypes.find(a => a.id === archetypeId);
    const inkColors = selectedArchetype?.ink_colors || [];
    const sortedNewColors = [...inkColors].sort().join(',');

    const normalized = normalizeDeckCards(rawCards);

    return allDecks.find(deck => {
        if (excludeDeckId && deck.id === excludeDeckId) return false;
        if (!deck.cards?.trim()) return false;

        const deckArchetype = archetypes.find(a => a.id === deck.archetype);
        const deckColors = deckArchetype?.ink_colors || deck.archetypeInfo?.ink_colors || [];
        if ([...deckColors].sort().join(',') !== sortedNewColors) return false;

        return normalizeDeckCards(deck.cards) === normalized;
    }) || null;
};

export const suggestDeckNames = (rawCards, archetypeId, allDecks, archetypes) => {
    if (!rawCards?.trim() || !archetypeId) return [];

    const archetype = archetypes.find(a => a.id === archetypeId);
    const archetypeName = archetype?.name || 'Talia';

    const sameArchetypeDecks = allDecks.filter(d => d.archetype === archetypeId);

    if (sameArchetypeDecks.length === 0) {
        return [`${archetypeName} v1`];
    }

    const frequencyMap = {};
    sameArchetypeDecks.forEach(deck => {
        const deckCards = Array.isArray(deck?.deckVisual?.cards) ? deck.deckVisual.cards : [];
        const seen = new Set();
        deckCards.forEach(card => {
            const key = normalizeCardName(`${card.name || ''} ${card.subtitle || ''}`);
            if (!seen.has(key)) {
                seen.add(key);
                frequencyMap[key] = (frequencyMap[key] || 0) + 1;
            }
        });
    });

    const total = sameArchetypeDecks.length;
    const newDeckCardNames = parseDeckCardNames(rawCards);

    const cardFrequencies = newDeckCardNames.map(name => ({
        name,
        pct: (frequencyMap[normalizeCardName(name)] || 0) / total
    }));

    cardFrequencies.sort((a, b) => a.pct - b.pct);

    const seen = new Set();
    const suggestions = [];
    for (const { name } of cardFrequencies) {
        if (suggestions.length >= 3) break;
        const suggestion = `${archetypeName} – ${name}`;
        if (!seen.has(suggestion)) {
            seen.add(suggestion);
            suggestions.push(suggestion);
        }
    }

    return suggestions.length > 0 ? suggestions : [`${archetypeName} v1`];
};
